export default "__VITE_ASSET__DTvcgJPS__"